import React from 'react';
import { XCircle, AlertCircle } from 'lucide-react';
import bgImage from '../../assets/home/bg-2.jpg';

const PAIN_POINTS = [
  'Search eBay, scan through listings',
  'Search TCGplayer, scan through listings',
  'Check Canadian card shop websites (if you even know they exist)',
  'Mentally compare prices, conditions, and shipping',
  "Hope you didn't miss a better deal",
];

export default function ProblemSection() {
  return (
    <section
      style={{ backgroundImage: `url(${bgImage})` }}
      className="relative border-y border-border-base bg-cover bg-center bg-no-repeat bg-fixed py-24"
    >
      <div className="absolute inset-0 z-0 bg-black/80 backdrop-blur-[8px]" />
      <div className="relative z-10 mx-auto max-w-4xl px-6">
        <div className="mb-16 text-center">
          <h2 className="font-landing-display text-3xl font-bold md:text-5xl">
            Buying Pokemon Cards Shouldn't Require <br className="hidden md:block" />
            <span className="text-brand-hi">Opening 5 Browser Tabs</span>
          </h2>
        </div>

        <div className="grid items-center gap-12 md:grid-cols-2">
          <div className="space-y-6 text-lg text-text-secondary">
            <p>Right now, finding the best deal on a card means:</p>
            <ul className="space-y-4">
              {PAIN_POINTS.map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <XCircle className="mt-1 shrink-0 text-chart-red" size={20} />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
            <div className="mt-8 flex items-start gap-3 rounded-xl border border-chart-red/20 bg-chart-red/10 p-4 text-text-primary">
              <AlertCircle className="mt-0.5 shrink-0 text-chart-red" size={20} />
              <p className="text-sm md:text-base">
                By the time you&apos;ve checked everywhere, the listing you wanted is sold.
              </p>
            </div>
          </div>

          <div className="relative overflow-hidden rounded-2xl border border-border-base bg-bg-card p-8 shadow-2xl">
            <div className="absolute left-0 top-0 h-1 w-full bg-gradient-to-r from-chart-red to-brand-primary" />
            <p className="text-xl font-medium leading-relaxed text-text-primary">
              Every other market has solved this problem. Flights have{' '}
              <span className="text-brand-hi">Skyscanner</span>. Hotels have{' '}
              <span className="text-brand-hi">Trivago</span>.
              <br />
              <br />
              But Pokemon cards? You&apos;re still manually checking multiple sites like it&apos;s 2005.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
